module.exports = __webpack_public_path__ + "img/b592ae40-d68a-11e8-828a-1334c9ae6ae8-image-square.e4a0f335.jpg";